/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowOrdersForDebtorQueryResponse, GetShowOrdersForDebtorPathParams, GetShowOrdersForDebtorQueryParams, GetShowOrdersForDebtor401 } from "../../models/GetShowOrdersForDebtor";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowOrdersForDebtorUrl({ debtorCode }: { debtorCode: GetShowOrdersForDebtorPathParams["debtorCode"] }) {
  const res = { method: 'GET', url: `/api/v1/debtors/${debtorCode}/orders` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/orders}
 */
export async function getShowOrdersForDebtor({ debtorCode, params }: { debtorCode: GetShowOrdersForDebtorPathParams["debtorCode"]; params: GetShowOrdersForDebtorQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowOrdersForDebtorQueryResponse, ResponseErrorConfig<GetShowOrdersForDebtor401>, unknown>({ method : "GET", url : getGetShowOrdersForDebtorUrl({ debtorCode }).url.toString(), params, ... requestConfig })  
  return res.data
}